// extracted by mini-css-extract-plugin
export default {"fieldset":"DadosDaSolicitacao_fieldset__52AMM","containerItems":"DadosDaSolicitacao_containerItems__wl33F"};